// Local translations
export const T = {
  en_GB: {
    tabsBlock: "Tabs Block",
    twoColumnBlock: "2-Column Block",
    settings: "Settings",
    configureConditional: "Configure conditional display for this layout block.",
    showBlockCondition: "Show this block only when a condition is met",
    failedToUpdate: "Failed to update layout",
    cancel: "Cancel",
    save: "Save",
  },
  nb_NO: {
    tabsBlock: "Faneblokk",
    twoColumnBlock: "2-kolonneblokk",
    settings: "Innstillinger",
    configureConditional: "Konfigurer betinget visning for denne layoutblokken.",
    showBlockCondition: "Vis denne blokken kun når en betingelse er oppfylt",
    failedToUpdate: "Kunne ikke oppdatere layout",
    cancel: "Avbryt",
    save: "Lagre",
  },
} as const;
